actual fun shouldRunAutomaticUpdateCheck(): Boolean = false
